import { createRouter, createWebHistory } from "@ionic/vue-router";
import type { RouteRecordRaw } from "vue-router";
import TeacherTabs from "../views/TeacherTabs.vue";
import StudentTabs from "../views/StudentTabs.vue";
import MergeTabs from "../views/merge/MergeTabs.vue";
import Register from "../views/Register.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/loading",
    component: () => import("@/views/loading.vue"),
  },
  // OEM 科目/平台中转页（按域名拉入口列表，单条自动跳转）
  {
    path: "/subject-transfer",
    name: "OemSubjectTransfer",
    component: () => import("@/views/OemSubjectTransfer.vue"),
  },
  // 兼容旧地址（开发代理曾误匹配 /oem-subject）
  {
    path: "/oem-subject",
    redirect: "/subject-transfer",
  },
  //登录
  {
    path: "/Login",
    component: () => import("@/views/Login.vue"),
  },

  {
    path: "/TeacherScheduleProfile",
    component: () => import("@/views/personal/TeacherScheduleProfile.vue"),
  },

  // 自习室-排课（独立页，不展示底部 Tab）
  {
    path: "/StudyRoomSchedule",
    component: () => import("@/views/StudyRoomSchedule.vue"),
  },

  // 陪练个人名片（纯展示；扫码进入带 from=scan，不显示返回）
  {
    path: "/TeacherProfileShowcase",
    component: () => import("@/views/personal/TeacherProfileShowcase.vue"),
    props: (route) => ({
      fromScan:
        route.query.from === "scan" ||
        route.query.fromScan === "1" ||
        route.query.viewMode === "visitor",
      account: route.query.account ? String(route.query.account) : "",
    }),
  },

  //注册
  {
    path: "/Register",
    component: Register,
  },

  //自定义文本展示演示页面
  {
    path: "/CustomTextDemo",
    component: () => import("@/views/CustomTextDemo.vue"),
  },

  //补充完善信息
  {
    path: "/Supplement",
    component: () => import("@/views/Supplement.vue"),
  },

  //用户反馈页
  {
    path: "/StudentFeedback",
    component: () => import("@/views/other/StudentFeedback.vue"),
  },
  {
    path: "/modal",
    name: "modal",
    component: () => import("@/components/componentModal.vue"),
  },
  //单词速记
  //speedVideo
  {
    path: "/speedVideo/Review/:studentId/:mastery",
    component: () => import("@/views/speedVideo/Review.vue"),
    props: true,
  },
  {
    path: "/speed/Review/:studentId/:mastery",
    component: () => import("@/views/speed/Review.vue"),
    props: true,
  },

  //reading
  {
    path: "/reading/Index",
    component: () => import("@/views/reading/Index.vue"),
    children: [
      //陪练备课，阅读理解列表
      {
        path: "/reading/IndexPrepare",
        component: () => import("@/views/reading/IndexPrepare.vue"),
        props: true,
      },
    ],
  },

  //强行提交练习结果
  {
    path: "/speedVideo/AfterTest/:studentId",
    component: () => import("@/views/speedVideo/AfterTest.vue"),
    props: true,
  },
  {
    path: "/speed/AfterTest/:studentId",
    component: () => import("@/views/speed/AfterTest.vue"),
    props: true,
  },
  //合并
  {
    path: "/merge",
    redirect: "/MergeIndex",
    component: MergeTabs,
    children: [
      //首页
      {
        path: "/MergeIndex",
        component: () => import("@/views/merge/MergeIndex.vue"),
        props: true,
      },

      //练习记录
      {
        path: "/MergeClassRecord",
        component: () => import("@/views/merge/MergeClassRecord.vue"),
        props: true,
      },

      //个人中心
      {
        path: "/MergePersonalIndex",
        component: () => import("@/views/merge/MergePersonalIndex.vue"),
      },
    ],
  },

  //陪练
  {
    path: "/teacher",
    redirect: () => {
      try {
        const user = JSON.parse(localStorage.getItem("userinfo") || "null")
        const raw = user?.platformFunction
        const set = new Set<number>()
        if (raw != null && raw !== "") {
          const list = Array.isArray(raw)
            ? raw
            : String(raw)
                .split(/[,，\s]+/)
                .filter(Boolean)
          list.forEach((v: any) => {
            const n = Number(v)
            if (n === 1 || n === 2) set.add(n)
          })
        }
        // 仅有自习室权限(2)时进入自习室，否则默认首页
        if (set.has(2) && !set.has(1)) return "/StudyRoom"
      } catch (e) {
        // ignore
      }
      return "/TeacherIndex"
    },
    component: TeacherTabs,
    children: [
      //陪练首页
      {
        path: "/TeacherIndex",
        component: () => import("@/views/TeacherIndex.vue"),
        props: true,
      },

      //自习室
      {
        path: "/StudyRoom",
        component: () => import("@/views/StudyRoom.vue"),
        props: true,
      },

      //用户管理
      {
        path: "/StudentList",
        component: () => import("@/views/other/StudentList.vue"),
        props: true,
      },

      //练习记录
      {
        path: "/ClassRecord",
        component: () => import("@/views/other/ClassRecord.vue"),
        props: true,
      },

      //个人中心
      {
        path: "/TeacherPersonalIndex",
        component: () => import("@/views/personal/TeacherPersonalIndex.vue"),
      },
      {
        // 教练设置
        path: "/TeacherSetting/:version",
        component: () => import("@/views/personal/TeacherSetting.vue"),
        props: true,
      },
      {
        // 教练个人中心
        path: "/TeacherPersonalCenter",
        component: () => import("@/views/personal/TeacherInfo.vue"),
        props: true,
      },
      {
        // 教练休息时间一览表
        path: "/teacherSchedule",
        component: () => import("@/views/personal/TeacherSchedule.vue"),
        props: true,
      },
      {
        // 教练休息申请
        path: "/teacherRestApply",
        component: () => import("@/views/personal/TeacherRestApply.vue"),
        props: true,
      },
      {
        // 语法模板
        path: "/grammarTemplate",
        component: () => import("@/views/grammar/GrammarTemplate.vue"),
        props: true,
      },
    ],
  },

  {
    path: "/student",
    component: StudentTabs,
    children: [
      {
        path: "/StudentIndex",
        component: () => import("@/views/StudentIndex.vue"),
      },
      {
        path: "/StudentRanking",
        component: () => import("@/views/other/StudentRanking.vue"),
        props: true,
      },
      {
        path: "/PersonalClassRecord",
        component: () => import("@/views/personal/PersonalClassRecord.vue"),
        props: true,
      },

      {
        path: "/StudentPersonalIndex",
        component: () => import("@/views/personal/StudentPersonalIndex.vue"),
        props: true,
      },
    ],
  },

  {
    path: "/personal/MyLessonsInfo",
    component: () => import("@/views/personal/MyLessonsInfo.vue"),
    props: true,
  },

  // ai
  {
    path: "/ai-generate/:value",
    component: () => import("@/views/AIGenerate/AIGenerate.vue"),
  },

  // ai 智阅
  {
    path: "/aiGenerate/smartReading/:studentInfo",
    name: "smartReading",
    component: () => import("@/views/AIGenerate/smartReading/smartReading.vue"),
  },

  // ai 短文列表
  {
    path: "/aiGenerate/assayList",
    name: "assayList",
    component: () => import("@/views/AIGenerate/essayList/EssayList.vue"),
  },

  // ai 短文生成
  {
    path: "/aiGenerate/assayGenerate/:studentInfo",
    name: "assayGenerate",
    component: () => import("@/views/AIGenerate/smartReading/newEssayGenerate.vue"),
  },
  // ai 智阅单词 & 短文生成
  {
    path: "/aiGenerate/SmartReadingWordModal/:studentInfo",
    name: "SmartReadingWordModal",
    component: () => import("@/views/AIGenerate/smartReading/SmartReadingWordModal.vue"),
  },
  // AI词典
  {
    path: "/ai-generate/dictionary",
    name: "SmartDictionary",
    component: () => import("@/views/AIGenerate/smartDictionary/smartDictionary.vue"),
  },
  // AI词典
  {
    path: "/ai-generate/tuling",
    name: "TuLing",
    component: () => import("@/views/AIGenerate/TuLing/TuLing.vue"),
  },
  // AI语法
  {
    path: "/ai-generate/analysis",
    name: "SmartAnalysis",
    component: () => import("@/views/AIGenerate/smartAnalysis/smartAnalysis.vue"),
  },
  // AI语法
  {
    path: "/ai-generate/essay",
    name: "SmartEssay",
    component: () => import("@/views/AIGenerate/smartEssay/smartEssay.vue"),
  },
  // ai客服
  {
    path: "/ai-generate/customer-service",
    name: "CustomerService",
    component: () => import("@/views/AIGenerate/customerService/customerService.vue"),
  },
  // AI听力
  {
    path: "/ai-generate/smart-listen",
    name: "smartListen",
    component: () => import("@/views/AIGenerate/smartListen/SmartListen.vue"),
  },
  // AI听力答题页面
  {
    path: "/smart-listen-answer/:id",
    name: "smartListenAnswer",
    component: () => import("@/views/AIGenerate/smartListen/ListenToAnswer.vue"),
  },
  // AI听力的解析
  {
    path: "/smart-listen-analysis/:id",
    name: "smartListenAnalysis",
    component: () => import("@/views/AIGenerate/smartListen/ListeningAnalysis.vue"),
  },
  // AI听力的听力精选
  {
    path: "/smart-listen-featured",
    name: "smartListenFeatured",
    component: () => import("@/views/AIGenerate/smartListen/ListeningFeatured.vue"),
  },
  // ai视频
  {
    path: "/ai-generate/smart-video",
    name: "smartVideo",
    component: () => import("@/views/AIGenerate/smartVideo/smartVideo.vue"),
  },
  // AI听口
  {
    path: "/ai-generate/smart-speak",
    name: "smartSpeak",
    component: () => import("@/views/AIGenerate/smartSpeak/smartSpeak.vue"),
  },
  // ai词根
  {
    path: "/ai-generate/root-dictionary",
    name: "SmartRootDictionary",
    component: () => import("@/views/AIGenerate/smartRootDictionary/smartRootDictionary.vue"),
  },
  {
    path: "/past-review",
    name: "PastReview",
    component: () => import("@/views/other/PastReview/PastReview.vue"),
  },
  // 学生端购买服务
  {
    path: "/student-buy-serve",
    name: "StudentBuyServe",
    component: () => import("@/views/other/StudentBuyServe.vue"),
  },
  // 学生端订单详情
  {
    path: "/student-order-detail",
    name: "StudentOrderDetail",
    component: () => import("@/views/other/StudentOrderDetail.vue"),
    props: true,
  },
  // 学生端我的订单
  {
    path: "/student-mine-order",
    name: "StudentMineOrder",
    component: () => import("@/views/other/StudentMineOrder.vue"),
    props: true,
  },
  // 听写单词
  {
    path: "/ai-generate/smart-dictate",
    name: "SmartDictate",
    component: () => import("@/views/AIGenerate/smartDictate/dictateBefore.vue"),
  },
  {
    path: "/Progress",
    component: () => import("@/views/personal/Progress.vue"),
    props: true,
  },
  {
    path: "/vocabulary-test",
    name: "VocabularyTest",
    component: () => import("@/views/personal/VocabularyTest.vue"),
  },
  {
    path: "/vocabulary-test-result",
    name: "VocabularyTestResult",
    component: () => import("@/views/personal/MyVocabularyTest.vue"),
  },
  {
    path: "/vocabulary-test-result-detail",
    name: "VocabularyTestResultDetail",
    component: () => import("@/views/personal/VocabularyTestResult.vue"),
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("@/views/personal/Forget21_2.vue"),
  },
  {
    path: "/train-room",
    component: () => import("@/views/liveVideo/pages/trainRoom.vue"),
  },
  {
    path:"/readingPrepare",
    component: () => import("@/views/reading/ReadingPrepare_admin.vue"),
  },
  {
    path:"/newReadingArticle",
    component: () => import("@/views/reading/newReadingArticle/ArticleIndex_admin.vue"),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
